export function useAttentive(){
  // Your implementation here

  function attentivePurchase(order){

    if(typeof window === 'undefined') {
        return;
    }
    if(typeof window.attentive === 'undefined' || !window.attentive.analytics) {
        return;
    }
    let attentivePayload = {};
    let items = [];
    for(let item of order.items) {
            items.push({
                'id': item.variation?.rothcoItem?.rothco_item_no,
                'productVariantId': item.variation?.item_variation_id,
                'name': item.variation?.item_name,
                'price': {
                    'value': item.price,
                    'currency': 'USD',
                },
                'quantity': item.quantity,
            });
        }
    attentivePayload['items'] = items;
    attentivePayload['order'] = order.order_id;
    attentivePayload['user'] = order.billing_phone;
    window.attentive.analytics.purchase(attentivePayload);
  }

  function attentiveAddToCart(item){

    if(typeof window === 'undefined') {
        return;
    }
    if(typeof window.attentive === 'undefined' || !window.attentive.analytics) {
        return;
    }
    let payload = {
        items: [
            {
                productId: item.rothcoItem.rothco_item_no,
                productVariantId: item.item_variation_id,
                price: {
                    value: item.price,
                    currency: 'USD',
                },
                quantity: item.quantity ? item.quantity : 1,
            }
        ]
    };

    window.attentive.analytics.addToCart(payload);
  }


  function attentiveProductView(item, quantity){

    if(typeof window === 'undefined') {
        return;
    }
    if(typeof window.attentive === 'undefined' || !window.attentive.analytics) {
        return;
    }
    let payload = {
        items: [
            {
                productId: item.rothcoItem.rothco_item_no,
                productVariantId: item.item_variation_id,
                name: item.item.name,
                price: {
                    value: item.price,
                    currency: 'USD',
                },
                quantity: quantity
            }
        ]
    };

    window.attentive.analytics.productView(payload);
  }

  return {
    attentivePurchase,
    attentiveAddToCart,
    attentiveProductView
  };
}
